(function($){    
    $(document).ready(function() {
        renderPowerReviews();
    });
})(jQuery);

function renderPowerReviews(){
    let prRenderConfig = [];

    let prElements = document.querySelectorAll('[data-pr-component]');
    prElements.forEach(function(element) {
        let prComponent = element.dataset.prComponent;
        let prPageId = element.dataset.prPage_id;
        let prApiKey = element.dataset.prApiKey;
        let prMerchantGroupId = element.dataset.prMerchantGroupId;
        let prMerchantId = element.dataset.prMerchantId;
        let prMounted = element.dataset.prMounted;
        
        if (prComponent && prPageId && !prMounted) {
            let componentConfig = {
                api_key: prApiKey,
                locale: 'en_US',
                merchant_group_id: prMerchantGroupId,
                merchant_id: prMerchantId,
                page_id: prPageId,
                review_wrapper_url: '/write-a-review/?',
                components: {}
            };
            if(prComponent == "CategorySnippet"){
                componentConfig['ENABLE_CLIENT_SIDE_STRUCTURED_DATA'] = false;
            }
            componentConfig.components[prComponent] = element.id;
            prRenderConfig.push(componentConfig);
        }
    });

    if(prRenderConfig.length > 0){
        window.pwr = window.pwr || function () {
            (pwr.q = pwr.q || []).push(arguments); 
        };
        pwr("render", prRenderConfig );
    }
}
